import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionProductionInfo, } from "../../info/production/actionProductionInfo";
export var epicSoundsBuildingProductionFinish = function (action$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionProductionInfo.Finish; }), tap(function () { return utilSound.event(IdEventSoundCore.BuildingProductionFinish); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsBuildingProductionFinish.ts
// module id = 2402
// module chunks = 3